import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "tab",
    "content",
    "subTab",
    "subContent",
    "newSubCategoryTemplate",
  ];

  connect() {
    this.showContent(0); // Default to showing the first category on load
    //this.observeSubCategories();
  }

  observeSubCategories() {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === "childList") {
          // Check if the added nodes are relevant to your targets
          mutation.addedNodes.forEach((node) => {
            if (
              node.dataset &&
              node.dataset.tariffServiceTypesTarget === "subTab"
            ) {
              const newSubIndex = this.subTabTargets.length - 1;
              node.dataset.subIndex = newSubIndex;
              node.addEventListener("click", (event) =>
                this.selectSubCategory(event)
              );
            }
            if (
              node.dataset &&
              node.dataset.tariffServiceTypesTarget === "subContent"
            ) {
              const newSubIndex = this.subContentTargets.length - 1;
              node.dataset.subIndex = newSubIndex;
            }
          });
        }
      });
    });

    // Configuration for the observer:
    const config = { childList: true, subtree: true };

    // Start observing the container for configured mutations
    this.subTabTargets.forEach((tab) =>
      observer.observe(tab.parentNode, config)
    );
    this.subContentTargets.forEach((content) =>
      observer.observe(content.parentNode, config)
    );
  }

  selectCategory(event) {
    const index = event.currentTarget.dataset.index;
    this.showContent(index);
  }

  showContent(index) {
    this.tabTargets.forEach((tab, idx) => {
      tab.classList.toggle("bg-gray-300", idx == index);
      tab.classList.toggle("text-blue-600", idx == index);
      tab.classList.toggle("text-gray-600", idx != index);
    });

    // Hide all content initially
    this.contentTargets.forEach((content) => content.classList.add("hidden"));

    // Show only the selected content
    if (this.contentTargets[index]) {
      this.contentTargets[index].classList.remove("hidden");
    }
  }


  selectSubCategory(event) {
    const subIndex = parseInt(event.currentTarget.dataset.subIndex);
    this.showSubContent(subIndex);
  }

  showSubContent(selectedSubIndex) {
    // Hide all sub-contents
    this.subContentTargets.forEach((content, idx) => {
      content.classList.toggle("hidden", idx !== selectedSubIndex);
    });

    // Update tab appearance
    this.subTabTargets.forEach((tab, idx) => {
      tab.classList.toggle("text-blue-600", idx === selectedSubIndex);
      tab.classList.toggle("text-gray-600", idx !== selectedSubIndex);
    });
  }
}
